<template>
<div>
    <div v-if="displayMultipleCollection" class="container mb-4">
        <span class="d-block font-weight-bold">{{ multipleCollectionSetting.heading }}</span>
        <div>
            <span class="d-inline-block font-weight-bold pb-3">{{ multipleCollectionSetting.text }}</span>
            <span class="d-inline-block icon ml-1 pb-3" v-b-popover.hover.bottomright="multipleCollectionSetting.note">&#9432;</span>
            <select v-model="multipleCollectionCount" class="d-inline-block ml-3 pb-3">
                <option v-for="i in totalEntitlement" :value="i" v-bind:key="i">{{i}}</option>
            </select>
        </div>  
    </div>
    </div>
</template>
<script>
    import helper from "../../../../helper";

    export default {
        data() {
            return {
                displayMultipleCollection: false,
                displayStreamQuantities: false,
                multipleCollectionCount: 1
            }
        },
        computed : {
            bookingState : function(){
                return this.$store.getters.GET_BOOKING_STATE;
            },
            serviceSettingSet() {
                return this.$store.getters.GET_ACTIVE_SERVICE_SETTING;
            },
            multipleCollectionSetting(){
                return this.$store.getters.GET_MULTIPLE_COLLECTION.list ? this.$store.getters.GET_MULTIPLE_COLLECTION.list[0] : null
            },
            selectedService(){
                var selectedService = this.$store.getters.GET_BOOKING_STATE.selectedService;
                var isServiceSelected = (selectedService && selectedService.service_setting_id) != null;
                return isServiceSelected ? selectedService : null;
            },
            effectiveCurrentEntitlements(){
                var effectiveEntitlements
                var entitlementSummary = this.$store.getters.GET_BOOKING_STATE.entitlementSummary
                if(entitlementSummary){
                    effectiveEntitlements = entitlementSummary.effectiveEntitlements;
                }
                return effectiveEntitlements.current
            },            
            totalEntitlement(){
                var totalEntitlement = 0
                
                if(!this.displayMultipleCollection){
                    return totalEntitlement
                }

                // Get the services entitlements
                var serviceEntitlementId = this.selectedService.entitlement_setting_id
                totalEntitlement = this.effectiveCurrentEntitlements[serviceEntitlementId]
                
                return totalEntitlement
            }
        },  
        mounted(){
            this.$store.dispatch('getMultipleCollection')
        },
        watch : {
            "selectedService" : function(newValue){
                // 1. Check if service exists and has entitlements
                // Reset the state on switch
                this.refreshBookingState()
                this.multipleCollectionCount = this.displayMultipleCollection ? 1 : null
                
            },
            "multipleCollectionCount" : function(newValue) {
                var bookingState = this.bookingState
                bookingState.multipleCollectionCount = newValue
                this.$store.dispatch("setBookingState", bookingState)
                this.refreshBookingState()
            }
        },
        methods: {
            refreshBookingState() {
                if(!this.selectedService 
                    || !this.effectiveCurrentEntitlements 
                    || !this.multipleCollectionSetting){
                    this.displayMultipleCollection = false
                    this.displayStreamQuantities = false
                }
                else{
                    // Check Multiple Entitled Collection for Display
                    if(this.selectedService.entitlement_setting_id !== null){
                        var multiEntitledCollection = this.multipleCollectionSetting.multi_entitled_collection
                        var foundEntitledService = multiEntitledCollection.find(enabledService =>{
                            return enabledService.service_setting_id == this.selectedService.service_setting_id 
                        })
                        this.displayMultipleCollection = foundEntitledService ? true : false
                    }
                    else
                        this.displayMultipleCollection = false
                    
                    

                    // Check Multi Collection for Waste Streams
                    var multiCollection = this.multipleCollectionSetting.multi_collection
                    var foundService = multiCollection.find(enabledService =>{
                        return enabledService.service_setting_id == this.selectedService.service_setting_id
                    })

                    // Also enable if Multi Entitled Count > 1
                    const multiEntitled = this.multipleCollectionCount && this.multipleCollectionCount > 1 
                    this.displayStreamQuantities = (foundService || multiEntitled) ? true : false
                }

                // Update Booking States
                var bookingState = this.bookingState
                var bookingStateChanged = false

                if(this.displayMultipleCollection !== bookingState.displayMultipleCollection){
                    bookingState.displayMultipleCollection = this.displayMultipleCollection
                    bookingStateChanged = true
                }
                if(this.displayStreamQuantities !== bookingState.displayStreamQuantities){
                    bookingState.displayStreamQuantities = this.displayStreamQuantities
                    bookingStateChanged = true
                }
                if(bookingStateChanged){
                    this.$store.dispatch("setBookingState", bookingState)
                }
            }
        },
    }
</script>

